var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "mb5" },
        [
          _c(
            "el-form",
            {
              attrs: { inline: false, "label-position": "top", size: "small" },
            },
            [
              _c(
                "el-row",
                {
                  staticStyle: { "flex-wrap": "wrap" },
                  attrs: { gutter: 20, type: "flex", justify: "left" },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 7 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "" } },
                        [
                          _c("template", { slot: "label" }, [
                            _c(
                              "div",
                              { staticClass: "selectLabel" },
                              [
                                _c(
                                  "el-select",
                                  {
                                    style: _vm.IsWidth,
                                    model: {
                                      value: _vm.queryForm.params.type,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryForm.params,
                                          "type",
                                          $$v
                                        )
                                      },
                                      expression: "queryForm.params.type",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      key: "1",
                                      attrs: {
                                        label: _vm.$t(
                                          "GlobalSetObj.messageTime"
                                        ),
                                        value: 1,
                                      },
                                    }),
                                    _c("el-option", {
                                      key: "2",
                                      attrs: {
                                        label: _vm.$t(
                                          "GlobalSetObj.newMessageTime"
                                        ),
                                        value: 2,
                                      },
                                    }),
                                    _c("el-option", {
                                      key: "3",
                                      attrs: {
                                        label: _vm.$t(
                                          "GlobalSetObj.newReplyTime"
                                        ),
                                        value: 3,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              clearable: false,
                              "default-time": ["00:00:00", "23:59:59"],
                              format:
                                _vm.$i18n.locale == "zh"
                                  ? _vm.zhDate
                                  : _vm.ptDate,
                              placeholder: _vm.$t("newOrder.SelectDatetime"),
                              "range-separator": "~",
                              type: "datetimerange",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                            },
                            model: {
                              value: _vm.timeValue,
                              callback: function ($$v) {
                                _vm.timeValue = $$v
                              },
                              expression: "timeValue",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.stateSite1"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.queryForm.params.state,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm.params, "state", $$v)
                                },
                                expression: "queryForm.params.state",
                              },
                            },
                            _vm._l(_vm.stateList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.nameEn,
                                  value: item.nameEn,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("collectionCenter.siteName") },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              on: { change: _vm.getUserList },
                              model: {
                                value: _vm.queryForm.params.siteId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm.params, "siteId", $$v)
                                },
                                expression: "queryForm.params.siteId",
                              },
                            },
                            _vm._l(_vm.siteList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("customerManagements.AccountName"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                "remote-method": _vm.searchGetUserList,
                                clearable: "",
                                filterable: "",
                                remote: "",
                                "reserve-keyword": "",
                              },
                              model: {
                                value: _vm.queryForm.params.userId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm.params, "userId", $$v)
                                },
                                expression: "queryForm.params.userId",
                              },
                            },
                            _vm._l(_vm.userList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.username, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("GlobalSetObj.requirement") },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.queryForm.params.messageType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "messageType",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.messageType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t(
                                    "GlobalSetObj.MaterialRequisition"
                                  ),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t(
                                    "GlobalSetObj.ComplaintsSuggestions"
                                  ),
                                  value: 2,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t(
                                    "GlobalSetObj.developmentRequirements"
                                  ),
                                  value: 3,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("GlobalSetObj.status") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                              },
                              model: {
                                value: _vm.queryForm.params.messageStatus,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "messageStatus",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.messageStatus",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("GlobalSetObj.all"),
                                  value: null,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("GlobalSetObj.Ongoing"),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("GlobalSetObj.Closed"),
                                  value: 2,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-col", { attrs: { span: 14 } }, [
                    _c(
                      "div",
                      { staticStyle: { "margin-top": "27px" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              icon: "el-icon-search",
                              size: "small",
                              type: "primary",
                            },
                            on: { click: _vm.enterSearch },
                          },
                          [_vm._v(_vm._s(_vm.$t("newOrder.search")) + " ")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              icon: "el-icon-refresh-left",
                              size: "small",
                              type: "info",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.resetForm()
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("newOrder.reset")) + " ")]
                        ),
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-bottom": "10px" },
                            attrs: { icon: "el-icon-upload2", size: "small" },
                            on: { click: _vm.allExportOrder },
                          },
                          [_vm._v(_vm._s(_vm.$t("newOrder.export")) + " ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "header-cell-style": { background: "#f2f2f2", color: "black" },
                border: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("GlobalSetObj.serial"),
                  align: "center",
                  type: "index",
                  width: "70",
                },
              }),
              _vm._l(_vm.tableHeaderList, function (item) {
                return _c("el-table-column", {
                  key: item.id,
                  attrs: {
                    label: item.label,
                    "min-width": item.cloWidth,
                    prop: item.prop,
                    "show-overflow-tooltip": true,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            item.prop === "messageStatusName"
                              ? _c(
                                  "div",
                                  [
                                    scope.row.messageStatus === 2
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              size: "small",
                                              type: "warning",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.messageStatusName
                                              ) + " "
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              size: "small",
                                              type: "",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.messageStatusName
                                              ) + " "
                                            ),
                                          ]
                                        ),
                                  ],
                                  1
                                )
                              : _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      scope.row[item.prop]
                                        ? "" + scope.row[item.prop]
                                        : "- -"
                                    )
                                  ),
                                ]),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("newOrder.operation"),
                  align: "center",
                  fixed: "right",
                  width: "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "flx-between" },
                          [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  content: _vm.$t("GlobalSetObj.Reply"),
                                  effect: "dark",
                                  placement: "top",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "iconfont icon-chakantiezihuifu textOperator2",
                                  on: {
                                    click: function ($event) {
                                      return _vm.replyMessage(scope.row)
                                    },
                                  },
                                }),
                              ]
                            ),
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  content: _vm.$t("GlobalSetObj.remark"),
                                  effect: "dark",
                                  placement: "top",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "iconfont icon-a-zu255 textOperator1",
                                  on: {
                                    click: function ($event) {
                                      return _vm.remarkMessage(scope.row)
                                    },
                                  },
                                }),
                              ]
                            ),
                            scope.row.messageStatus != 2
                              ? _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      content: _vm.$t("GlobalSetObj.Close"),
                                      effect: "dark",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "iconfont icon-guanbi textOperator",
                                      on: {
                                        click: function ($event) {
                                          return _vm.closeMessage(scope.row.id)
                                        },
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            2
          ),
          _c("el-pagination", {
            staticStyle: { margin: "10px 0", float: "right" },
            attrs: {
              "current-page": _vm.queryForm.pageNumber,
              "page-size": _vm.queryForm.pageSize,
              "page-sizes": [10, 20, 50, 100],
              total: _vm.queryForm.total,
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          staticClass: "drawerClass",
          attrs: {
            "close-on-click-modal": true,
            "destroy-on-close": true,
            title: _vm.$t("GlobalSetObj.MessageContent"),
            visible: _vm.seeDialogVisible,
            direction: "ltr",
            size: "1000px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.seeDialogVisible = $event
            },
            close: _vm.closeDrawer,
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                padding: "10px 20px 0 20px",
                "overflow-y": "auto",
                height: "calc(100% - 80px)",
              },
            },
            [
              _c(
                "el-form",
                {
                  ref: "dialogFormRef",
                  staticClass: "demo-ruleForm",
                  attrs: {
                    inline: false,
                    model: _vm.replyData,
                    "label-position": "top",
                    size: "default",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c(
                          "div",
                          {
                            ref: "messageListRef",
                            staticClass: "messgeList",
                            style: _vm.IsHeight,
                          },
                          _vm._l(_vm.detailData, function (item) {
                            return _c("div", { key: item.id }, [
                              item.self
                                ? _c("div", { staticClass: "selfMessage" }, [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "margin-bottom": "10px",
                                        },
                                      },
                                      [
                                        _c("span", { staticClass: "pepole" }, [
                                          _vm._v(
                                            _vm._s(item.createUserName || "--")
                                          ),
                                        ]),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-left": "10px",
                                            },
                                          },
                                          [_vm._v(_vm._s(item.createTime))]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "pepoleMessage" },
                                      [_vm._v(" " + _vm._s(item.message) + " ")]
                                    ),
                                  ])
                                : _c("div", { staticClass: "otherMessage" }, [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "margin-bottom": "10px",
                                        },
                                      },
                                      [
                                        _c("span", { staticClass: "pepole" }, [
                                          _vm._v(
                                            _vm._s(item.createUserName || "--")
                                          ),
                                        ]),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-left": "10px",
                                            },
                                          },
                                          [_vm._v(_vm._s(item.createTime))]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "pepoleMessage" },
                                      [_vm._v(_vm._s(item.message))]
                                    ),
                                  ]),
                            ])
                          }),
                          0
                        ),
                      ]),
                      _vm.isColse
                        ? _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    rules: [
                                      {
                                        required: true,
                                        message: _vm.$t(
                                          "GlobalSetObj.pleaseInput"
                                        ),
                                        trigger: "blur",
                                      },
                                    ],
                                    label: "",
                                    prop: "replyTextArea",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      autosize: { minRows: 10, maxRows: 11 },
                                      placeholder: _vm.$t(
                                        "GlobalSetObj.pleaseInput"
                                      ),
                                      maxlength: "1000",
                                      "show-word-limit": "",
                                      type: "textarea",
                                    },
                                    nativeOn: {
                                      keydown: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        $event.preventDefault()
                                        return _vm.replyMessageSubmit($event)
                                      },
                                    },
                                    model: {
                                      value: _vm.replyData.replyTextArea,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.replyData,
                                          "replyTextArea",
                                          $$v
                                        )
                                      },
                                      expression: "replyData.replyTextArea",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.isColse
                ? _c(
                    "div",
                    { staticStyle: { "text-align": "right" } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "custom-button",
                          attrs: { type: "primary" },
                          on: { click: _vm.replyMessageSubmit },
                        },
                        [_vm._v(_vm._s(_vm.$t("GlobalSetObj.Reply")) + " ")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.$t("GlobalSetObj.remark"),
            visible: _vm.messageRemrkDialog,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.messageRemrkDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "remarkBox" },
            [
              _c("el-input", {
                attrs: {
                  autosize: { minRows: 8, maxRows: 15 },
                  placeholder: _vm.$t("collectionCenter.pleaseInput"),
                  maxlength: "200",
                  "show-word-limit": "",
                  type: "textarea",
                },
                model: {
                  value: _vm.messageRemrk,
                  callback: function ($$v) {
                    _vm.messageRemrk = $$v
                  },
                  expression: "messageRemrk",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.messageRemrkSubmit(1)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.cancel")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.messageRemrkSubmit(2)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.confirm")) + " ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }